import { EMPTY } from '@shared/utils/strings';
import formatAmount from '@shared/utils/formatAmount';
export default function formatOptionalAmount(amount, defaultString = EMPTY) {
    return amount === null || amount === undefined ? defaultString : formatAmount(amount);
}
